(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProductPrice', ProductPrice);

    ProductPrice.$inject = ['$resource', 'DateUtils'];

    function ProductPrice ($resource, DateUtils) {
        var resourceUrl =  'api/product-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedDate = DateUtils.convertLocalDateFromServer(data.startedDate);
                        data.endedDate = DateUtils.convertLocalDateFromServer(data.endedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startedDate = DateUtils.convertLocalDateToServer(data.startedDate);
                    data.endedDate = DateUtils.convertLocalDateToServer(data.endedDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startedDate = DateUtils.convertLocalDateToServer(data.startedDate);
                    data.endedDate = DateUtils.convertLocalDateToServer(data.endedDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
